var options={use:true};export default options;